import { UserCheck, Building2, Scale, Sparkles, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { scrollToId } from "@/lib/lenis";

const STEPS = [
  {
    icon: UserCheck,
    num: "01",
    title: "Jeden styčný bod",
    text: "Petr Lehnert funguje jako váš hlavní organizátor, stavební dozor a kontrolor kvality v jedné osobě. Všichni prověření řemeslníci na sebe plynule navazují. Vy neřešíte nic.",
  },
  {
    icon: Building2,
    num: "02",
    title: "Žádné placení úředníků",
    text: "Neplatíte korporátní marže za manažery v kancelářích. Vaše peníze jdou do kvalitního materiálu a lidem, kteří na vaší stavbě skutečně fyzicky pracují.",
  },
  {
    icon: Scale,
    num: "03",
    title: "Zlatá střední cesta",
    text: "Řemeslník dostane férově zaplaceno za precizní práci — nemusí ji šidit kvůli podhodnocení od velké firmy. A vy získáte špičkové know-how za mnohem lepší cenu.",
  },
  {
    icon: Sparkles,
    num: "04",
    title: "Pořádek jako standard",
    text: "Na stavbě i kolem ní udržujeme pořádek nepřetržitě — každý den po práci uklízíme a vše dáváme na své místo. Čistá stavba je bezpečná stavba a váš pozemek netrpí.",
  },
];

export default function NeFirma() {
  return (
    <section
      id="ne-firma"
      data-testid="nefirma-section"
      className="py-24 lg:py-36 bg-coal/60 relative overflow-hidden"
    >
      <span
        aria-hidden="true"
        className="absolute top-2 left-1/2 -translate-x-1/2 font-sans font-extrabold uppercase whitespace-nowrap outline-text select-none pointer-events-none text-[16.5vw] lg:text-[8rem] leading-none"
      >
        NE-FIRMA
      </span>

      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative">
        <Reveal>
          <div className="max-w-3xl">
            <div
              className="inline-flex flex-col items-start gap-1 border border-gold/50 bg-gold/10 rounded-2xl px-5 py-3 mb-8"
              data-testid="nefirma-badge"
            >
              <span className="text-xs font-mono tracking-[0.18em] uppercase text-gold-light">
                Jsme vaše stavební NE-FIRMA
              </span>
              <span className="text-xs font-mono tracking-[0.18em] uppercase text-gold-light">
                Jsme aliance řemeslníků
              </span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-6xl text-zinc-100 leading-tight">
              Nemáte čas řídit stavbu?{" "}
              <span className="gold-text">Na to přece nepotřebujete drahou firmu.</span>
            </h2>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 grid md:grid-cols-2 gap-8 max-w-5xl">
            <p className="text-zinc-400 leading-relaxed">
              Spousta lidí si najme velkou stavební firmu z jediného důvodu — chodí do práce,
              mají rodinu a nemají čas obvolávat a organizovat jednotlivé řemeslníky. Zvolí
              firmu, protože chtějí klid. Realita? Často zaplatí obrovské marže za kanceláře a
              manažery, ale jejich stavba stejně stojí, termíny se posouvají a na místě nikdo
              nepracuje.
            </p>
            <p className="text-zinc-300 leading-relaxed border-l-2 border-gold/50 pl-6">
              V <span className="text-gold-light font-semibold">RESTART PRO</span> to děláme
              jinak. Získáváte veškeré výhody velké firmy — odbornost, garance a plynulou
              návaznost prací — ale za férovější ceny přímo od prověřených živnostníků.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.08} className="h-full">
              <div
                data-testid={`nefirma-step-${i}`}
                className="group h-full bg-ink/70 backdrop-blur border border-white/5 hover:border-gold/35 rounded-xl p-7 transition-colors duration-500"
              >
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 rounded-lg bg-gold/10 border border-gold/25 flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-black transition-colors duration-300">
                    <s.icon size={19} />
                  </span>
                  <span className="font-mono text-xs text-gold/40">{s.num}</span>
                </div>
                <h3 className="mt-5 text-lg font-semibold text-zinc-100">{s.title}</h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-14 text-center">
            <button
              onClick={() => scrollToId("kontakt")}
              data-testid="nefirma-cta"
              className="inline-flex items-center gap-3 bg-gold text-black font-bold text-base sm:text-lg rounded-full px-10 py-4 hover:bg-gold-light transition-colors gold-glow"
            >
              Svěřte nám starosti se stavbou <ArrowRight size={19} />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
